import {
  BIKES_RESET,
  BIKE_SENDING,
  BIKE_DOWNLOADED,
  BIKES_DOWNLOADED,
  BIKES_FAILED,
  BIKES_PENDING,
} from './types';

export const INITIAL_STATE = {
  error: null,
  content: null,
  pending: false,
  sending: false,
};

export default function (state = INITIAL_STATE, action) {
  let bikes = [];
  let bikeIndex = -1;
  switch (action.type) {
    case BIKES_RESET:
      return INITIAL_STATE;
    case BIKES_PENDING:
      return {
        ...state,
        error: null,
        pending: true,
      };
    case BIKES_DOWNLOADED:
      return {
        error: null,
        pending: false,
        sending: false,
        content: action.payload,
      };
    case BIKE_SENDING:
      return {
        ...state,
        sending: true,
      };
    case BIKE_DOWNLOADED:
      if (state.content) {
        bikes = state.content.slice();
        bikeIndex = bikes.findIndex((bike) => bike.id === action.payload.id);
      }
      if (bikeIndex === -1) {
        bikes.push(action.payload);
      } else {
        bikes[bikeIndex] = action.payload;
      }
      return {
        error: null,
        pending: false,
        sending: false,
        content: bikes,
      };
    case BIKES_FAILED:
      return {
        ...state,
        error: action.payload,
        pending: false,
        sending: false,
      };
    default:
      break;
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/store/bikes/reducers.js